export const homepage_tour_steps = (t, debtor, userPermissions) => {
	const steps = [
		/* --------------------------------- Header --------------------------------- */

		{
			element: '[driverjs-element="username"]',
			popover: {
				align: "start",
				description: t("driver_tour.homepage_tour.steps.username.description"),
				side: "bottom",
				title: t("driver_tour.homepage_tour.steps.username.title"),
			},
		},

		{
			element: '[driverjs-element="relations"]',
			popover: {
				align: "center",
				description: t("driver_tour.homepage_tour.steps.relations.description"),
				side: "bottom",
				title: t("driver_tour.homepage_tour.steps.relations.title"),
			},
		},
		/* --------------------------------- sidebar -------------------------------- */

		{
			element: '[driverjs-element="products_and_services"]',
			popover: {
				align: "center",
				description: t("driver_tour.homepage_tour.steps.products_and_services.description"),
				side: "bottom",
				title: t("driver_tour.homepage_tour.steps.products_and_services.title"),
			},
		},
		{
			element: '[driverjs-element="shortcuts"]',
			popover: {
				align: "center",
				description: t("driver_tour.homepage_tour.steps.shortcuts.description"),
				side: "right",
				title: t("driver_tour.homepage_tour.steps.shortcuts.title"),
			},
		},
		/* --------------------------------- center --------------------------------- */
		{
			element: '[driverjs-element="homepage"]',
			popover: {
				align: "center",
				description: t("driver_tour.homepage_tour.steps.homepage.description"),
				side: "top",
				title: t("driver_tour.homepage_tour.steps.homepage.title"),
			},
		},
	];

	// Add items at index 1 of the steps list (After #username) based on membership type
	if (
		debtor.membership_type === "business" &&
		userPermissions.data.some((permission) => permission.category === "company")
	) {
		steps.splice(
			1,
			0,
			{
				element: '[driverjs-element="company"]',
				popover: {
					align: "center",
					description: t("driver_tour.homepage_tour.steps.company.description"),
					side: "bottom",
					title: t("driver_tour.homepage_tour.steps.company.title"),
				},
			},
			{
				element: '[driverjs-element="personal"]',
				popover: {
					align: "center",
					description: t("driver_tour.homepage_tour.steps.personal.business.description"),
					side: "bottom",
					title: t("driver_tour.homepage_tour.steps.personal.title"),
				},
			},
		);
	} else {
		steps.splice(1, 0, {
			element: '[driverjs-element="personal"]',
			popover: {
				align: "center",
				description: t("driver_tour.homepage_tour.steps.personal.private.description"),
				side: "bottom",
				title: t("driver_tour.homepage_tour.steps.personal.title"),
			},
		});
	}

	return steps;
};
